import pdfIcon from "../../assets/userProfil/pdf_icon.png";
import powerpointIcon from "../../assets/userProfil/powerpoint_icon.png";
import excelIcon from "../../assets/userProfil/excel_icon.png";
import defaultFileIcon from "../../assets/userProfil/defaultFile_icon.png";
import { Button } from "../ui/button";
interface TrainingFileProps {
	file: {
		id: number;
		name: string;
		url: string;
	};
}

const formatFileName = (fileName: string): string => {
	// Remove file extension
	const withoutExtension = fileName.replace(/\.(pdf|pptx|xlsx)$/i, "");
	// Replace underscores and hyphens with spaces
	return withoutExtension.replace(/[_-]/g, " ");
};

const chooseIconBasedOnFileType = (fileName: string): string => {
	const fileExtension = fileName.split(".").pop();
	switch (fileExtension) {
		case "pdf":
			return pdfIcon;
		case "pptx":
			return powerpointIcon;
		case "xlsx":
			return excelIcon;
		default:
			return defaultFileIcon;
	}
};

const downloadFile = (file: {
	id: number;
	name: string;
	url: string;
}): void => {
	const link = document.createElement("a");
	link.href = file.url;
	link.download = file.name;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};

export const TrainingFile = ({ file }: TrainingFileProps): JSX.Element => {
	return (
		<div key={file.id} className="mb-[15px] bg-white rounded-[8px] p-4">
			<div className="flex mb-[13px]">
				<img
					alt="resource image"
					className="max-w-[49px] max-h-[49px]"
					src={chooseIconBasedOnFileType(file.url)}
				/>
				<p className="ml-[10px] font-medium">{formatFileName(file.name)}</p>
			</div>
			<div className="flex items-end justify-end">
				<Button
					className=" border-[1px] border-[#919EAB3D]  h-[30px] mr-[10px] px-2 py-1"
					variant="ghost"
					onClick={() => {
						downloadFile(file);
					}}
				>
					Pobierz
				</Button>
			</div>
		</div>
	);
};
